import { getFolios } from '../math';
import { floatToP2Float } from '../ui';
import { PricingFunction } from './types';

export const priceFolio: PricingFunction = options => {
  const { displayParameters, applicableRate } = options;
  const { folioSize } = options.rateRecord;
  return floatToP2Float(
    getFolios({ words: displayParameters.words || 0, folioSize }) *
      applicableRate
  );
};
